export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const removeUser = () => {
  localStorage.removeItem('user');
};

export const logout = async () => {
  try {
    // Call logout API to clear server-side session
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    await fetch(`${API_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include'
    });
  } catch (error) {
    console.error('Logout API error:', error);
  }
  
  // Clear local storage
  removeToken();
  removeUser();
};

export const isAuthenticated = () => {
  return !!getToken() || !!getUser();
};

export const getUserRole = () => {
  const user = getUser();
  return user ? user.role : null;
};

// Initiate Google OAuth login using your own Google credentials
export const initiateGoogleLogin = async (redirectPath = '/dashboard/seeker') => {
  try {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${API_URL}/api/auth/google/login?redirect_path=${encodeURIComponent(redirectPath)}`);
    const data = await response.json();
    
    if (data.auth_url) {
      // Check if we're in an iframe (embed mode)
      const isInIframe = window.self !== window.top;
      
      if (isInIframe) {
        // Open in new window/tab for iframe compatibility
        // Google OAuth doesn't work inside iframes due to security restrictions
        window.open(data.auth_url, '_blank', 'width=500,height=600,scrollbars=yes');
      } else {
        // Normal redirect for standalone mode
        window.location.href = data.auth_url;
      }
    } else {
      console.error('No auth URL returned from server');
    }
  } catch (error) {
    console.error('Error initiating Google login:', error);
  }
};